module.exports = __webpack_public_path__ + "img/NL495.22fb1e13.png";